import { QuoteComparisonAnimation } from '@/components/quotes/QuoteComparisonAnimation/QuoteComparisonAnimation'
import { ProductBlankState } from '@/components/sidebar'
import { INSURANCE_BLANK_STATE } from './sidebar/navigation'

/** Insurance's offer, for a fleet without cover or an account with no Insure user at all. */
export function InsuranceOffer() {
  return (
    <ProductBlankState {...INSURANCE_BLANK_STATE} preview={<QuoteComparisonAnimation className="w-full" />} />
  )
}
